const chartNode = item => {
  const node = {
    nodeId: item.id,
    parentNodeId: item.partentNodeId,
    width: 342,
    height: 130,
    borderWidth: 1,
    borderRadius: 5,
    borderColor: {
      red: 20,
      green: 30,
      blue: 48,
      alpha: .19
    },
    backgroundColor: {
      red: 20,
      green: 30,
      blue: 48,
      alpha: 1
    },
    nodeImage: item.nodeImage,
    nodeIcon: item.nodeIcon,
    template: item.template,
    connectorLineColor: {
      red: 20,
      green: 30,
      blue: 48,
      alpha: .19
    },
    connectorLineWidth: 5,
    dashArray: "",
    expanded: false,
    directSubordinates: 4,
    totalSubordinates: 1515
  }
  return node;
}

export default chartNode;